export const GET_ENTRYPOINTS_LIVES = "GET_ENTRYPOINTS_LIVES";
export const GET_ENTRYPOINTS_LIVES_SUCCESS = "GET_ENTRYPOINTS_LIVES_SUCCESS";
export const GET_ENTRYPOINTS_LIVES_ERROR = "GET_ENTRYPOINTS_LIVES_ERROR";
export const GET_FEATURED_LIVES = "GET_FEATURED_LIVES";
export const GET_FEATURED_LIVES_SUCCESS = "GET_FEATURED_LIVES_SUCCESS";
export const GET_FEATURED_LIVES_ERROR = "GET_FEATURED_LIVES_ERROR";
export const GET_NEXT_LIVES = "GET_NEXT_LIVES";
export const GET_NEXT_LIVES_SUCCESS = "GET_NEXT_LIVES_SUCCESS";
export const GET_NEXT_LIVES_ERROR = "GET_NEXT_LIVES_ERROR";
